import { Component, EventEmitter, inject, input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownMenuComponent } from 'app/shared/ui/dropdown/dropdown-menu.component';
import { DropdownToggleDirective } from 'app/shared/ui/dropdown/dropdown-toggle.directive';
import { DropdownDirective } from 'app/shared/ui/dropdown/dropdown.directive';
import { TooltipDirective } from 'app/shared/ui/tooltip/tooltip.directive';


@Component({
    selector: 'ui-page-select-menu',
    imports: [
        DropdownMenuComponent,
    ],
    template: `
        <ui-dropdown-menu>
            <button
                (click)="host.selectAll.emit(!host.selected())"
                class="dropdown-item">
                {{ !host.selected() ? 'Select all pages' : 'Deselect all pages' }}
            </button>
        </ui-dropdown-menu>
    `,
})
export class PageSelectMenuComponent {

    host = inject(PageSelectComponent);
}


@Component({
    selector: 'ui-page-select',
    imports: [
        DropdownDirective,
        DropdownToggleDirective,
        FormsModule,
        TooltipDirective,
    ],
    template: `
        <div [uiDropdown]="menu" #dropdown="dropdown" class="btn-group btn-group-sm">
            <label
                class="btn btn-secondary mb-0 d-flex align-items-center px-2"
                [tooltip]="!selected() ? 'Select visible' : 'Deselect visible'"
                tooltipPlacement="right">
                <input type="checkbox" [ngModel]="selected()" (ngModelChange)="selectPage.emit(!selected())">
            </label>
            <button
                [dropdownToggle]="true"
                class="btn btn-secondary px-2"
                tooltip="Show more options"
                tooltipPlacement="right"
                [tooltipDisabled]="dropdown.isOpen()">
            </button>
        </div>
    `,
})
export class PageSelectComponent {

    selected = input.required<boolean>();

    @Output() selectAll = new EventEmitter<boolean>();

    @Output() selectPage = new EventEmitter<boolean>();

    menu = PageSelectMenuComponent;
}
